"use client";

import { LegacyButton, Text } from "@zapier/design-system";
import { Metadata } from "next";

export const metadata: Metadata = {
  title: `Not Found | Zapier`,
};

const NotFound = () => {
  return (
    <div className="not_found">
      <Text tag="h1" textAlign="center" type="SectionHeader">
        404: Page Not Found
      </Text>
      <Text tag="p" textAlign="center">
        Not all who wander are lost...but you are.
      </Text>
      <LegacyButton color="primary" href="/">
        Back to safety
      </LegacyButton>
    </div>
  );
};

export default NotFound;
